var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-btn-icon", {
    attrs: { "btn-text": "Affectation", color: "primary", icon: "search" },
    on: {
      click: function($event) {
        $event.stopPropagation()
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }